import { Box, Button, Checkbox, Container, Flex, FormControl, FormLabel, HStack, Image, Input, Link, Stack, useColorMode, useColorModeValue } from '@chakra-ui/react'
import React from 'react'

import { FcGoogle } from 'react-icons/fc'
import { IoLogIn, IoMoon, IoSunny } from "react-icons/io5";
import loginBg from '../img/loginBg.jpg'

import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { doc, getFirestore, setDoc } from "firebase/firestore";
import { firebaseApp } from "../firebase-config";
import { useNavigate } from 'react-router-dom';

import darkLogo from "../img/darkLogo.png";
import lightLogo from "../img/lightLogo.png";


const Login = () => {

    const firebaseAuth = getAuth(firebaseApp);
    const provider = new GoogleAuthProvider();
    const firebaseDb = getFirestore(firebaseApp)
    const navigate = useNavigate();

    const { colorMode, toggleColorMode } = useColorMode();
    const bg = useColorModeValue('gray.600', 'gray.300');

    const login = async () => {
        const { user }
            = await signInWithPopup(firebaseAuth, provider);
        const { refreshToken, providerData }
            = user
        console.log(refreshToken, providerData)


        localStorage.setItem("user", JSON.stringify(providerData))
        localStorage.setItem("accessToken", JSON.stringify(refreshToken))


        await setDoc(doc(firebaseDb, 'users', providerData[0].uid), providerData[0]
        );

        navigate('/', { replace: true })
    }


    return (
        <Container mt={8}        >
            <Container
                borderWidth={1}
                px={4}
                mt={10}
                width='full'
                maxWidth={'500px'}
                borderRadius={4}
                textAlign='center'
                boxShadow='lg'
            >
                <Flex
                    justifyContent={'space-between'}
                    alignItems='center'
                    width={'full'}
                >
                    <Image
                        src={colorMode == 'light' ? darkLogo : lightLogo}
                        width={{ base: '180px', md: '150px', lg: '180px' }}
                    />
                    <Box
                        alignItems='center'
                        cursor={'pointer'}
                        onClick={toggleColorMode}
                    >
                        {colorMode == 'light' ? (
                            <IoMoon fontSize={30} />
                        ) : (
                            <IoSunny fontSize={30} />
                        )
                        }
                    </Box>
                </Flex>
            </Container>
            <Container
                borderWidth={1}
                px={4}
                mt={10}
                width='full'
                maxWidth={'500px'}
                borderRadius={4}
                textAlign='center'
                boxShadow='lg'
            >
                <Flex
                    justifyContent={'center'}
                    alignItems='center'
                    width={'full'}
                >
                <HStack
                            justifyContent={'center'}
                            alignItems={'center'}
                        >
                            <Button
                                leftIcon={<FcGoogle fontSize={25} />}
                                colorScheme="blackAlpha"
                                shadow={"lg"}
                                width={'100%'}
                                mt={4}
                                mb={4}
                                onClick={() => login()}
                                color='#f1f1f1'
                            >
                                SignIn with Google
                            </Button>
                        </HStack>
                </Flex>
            </Container>
        </Container>
    )
}

export default Login


{/*  <Box
                    textAlign='left'
                >
                    <form>
                        <FormControl>
                            <FormLabel>
                                Email Address
                            </FormLabel>
                            <Input type='email' placeholder='Enter Your email address' />
                            <FormLabel>
                                Password
                            </FormLabel>
                            <Input type='Password' placeholder='Enter Your password' />
                        </FormControl>
                        <Stack isInline justifyContent='space-between' mt={4}>
                            <Box>
                                <Checkbox>Remember Me</Checkbox>
                            </Box>
                            <Box>
                                <Link color={'teal.500'}>Forgot your password?</Link>
                            </Box>
                        </Stack>

                        <HStack
                            justifyContent={'center'}
                            alignItems='center'
                            mt={4}
                        >
                            <Button
                                leftIcon={<IoLogIn fontSize={25} />}
                                justifyContent={'center'}
                                alignItems='center'
                                colorScheme={'teal'}
                                width={'70%'}
                                mt={4}
                            >
                                Sign In
                            </Button>
                        </HStack>


                        <HStack
                            justifyContent={'center'}
                            alignItems={'center'}
                        >
                            <Button
                                leftIcon={<FcGoogle fontSize={25} />}
                                colorScheme="blackAlpha"
                                shadow={"lg"}
                                width={'70%'}
                                mt={4}
                                mb={4}
                                onClick={() => login()}
                                color='#f1f1f1'
                            >
                                SignIn with Google
                            </Button>
                        </HStack>
                    </form>
                </Box> */}
